import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/PublicLayout";
import PageViewTracker from "@/components/PageViewTracker";

import Home from "@/pages/Home";
import Approche from "@/pages/Approche";
import Realisations from "@/pages/Realisations";
import RealisationDetail from "@/pages/RealisationDetail";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Devis from "@/pages/Devis";
import Contact from "@/pages/Contact";
import MentionsLegales from "@/pages/MentionsLegales";
import CityPage from "@/pages/CityPage";
import { CITY_LIST } from "@/data/cities";

import ScrollToTop from "@/components/ScrollToTop";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminQuotes from "@/pages/admin/QuotesAdmin";
import AdminCallbacks from "@/pages/admin/CallbacksAdmin";
import AdminTestimonials from "@/pages/admin/TestimonialsAdmin";
import AdminBlog from "@/pages/admin/BlogAdmin";
import AdminProjects from "@/pages/admin/ProjectsAdmin";
import BlogEditor from "@/pages/admin/BlogEditor";

export default function App() {
    useEffect(() => {
        // Schema.org Organization (global)
        const existing = document.getElementById("ld-org");
        if (existing) existing.remove();
        const ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "ld-org";
        ld.innerText = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "@id": "https://japet-agencement.fr/#organization",
            "name": "Japet Agencement",
            "description": "Société de rénovation d'intérieurs haut de gamme à Paris et en Île-de-France.",
            "url": "https://japet-agencement.fr",
            "logo": "https://japet-agencement.fr/japet-logo.png",
            "image": "https://japet-agencement.fr/japet-logo.png",
            "email": "contact@japet-agencement.fr",
            "areaServed": ["Paris", "Île-de-France"],
            "address": { "@type": "PostalAddress", "addressCountry": "FR", "addressRegion": "Île-de-France" },
            "priceRange": "€€€€",
            "sameAs": [],
        });
        document.head.appendChild(ld);
    }, []);

    return (
        <AuthProvider>
            <BrowserRouter>
                <ScrollToTop />
                <PageViewTracker />
                <Routes>
                    <Route element={<PublicLayout />}>
                        <Route index element={<Home />} />
                        <Route path="/approche" element={<Approche />} />
                        <Route path="/realisations" element={<Realisations />} />
                        <Route path="/realisations/:slug" element={<RealisationDetail />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogArticle />} />
                        <Route path="/devis" element={<Devis />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/mentions-legales" element={<MentionsLegales />} />
                        {CITY_LIST.map((c) => (
                            <Route key={c.slug} path={`/renovation-${c.slug}`} element={<CityPage />} />
                        ))}
                    </Route>

                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute>
                                <AdminLayout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<AdminDashboard />} />
                        <Route path="quotes" element={<AdminQuotes />} />
                        <Route path="callbacks" element={<AdminCallbacks />} />
                        <Route path="projects" element={<AdminProjects />} />
                        <Route path="testimonials" element={<AdminTestimonials />} />
                        <Route path="blog" element={<AdminBlog />} />
                        <Route path="blog/new" element={<BlogEditor />} />
                        <Route path="blog/:id" element={<BlogEditor />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster richColors position="top-right" />
        </AuthProvider>
    );
}
